import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import UserInfo from 'view/userInfo';

const UserManagePage = () => {
	return (
		<PageTemplate>
			<UserInfo />
		</PageTemplate>
	);
};

export default UserManagePage;

 